module.exports = __webpack_public_path__ + "assets/img/down_1.da3fe44d.png";